exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cap-checkbox-v2 .title{padding-left:.285rem}.cap-checkbox-v2 .inductive-text{padding-left:2.857rem}.cap-checkbox-v2 .title.has-suffix{margin-right:8px}.cap-checkbox-v2 .ant-checkbox-wrapper-disabled{opacity:0.5}.cap-checkbox-v2 .ant-checkbox-inner{margin:.285rem;width:1.428rem;height:1.428rem;border:2px solid #b3bac5}.cap-checkbox-v2 .ant-checkbox-checked .ant-checkbox-inner::after{left:23%}\n", ""]);

// exports
